import { Component, NgModule, OnInit, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { DataService } from 'src/app/service/data.service';
import { ProgressService } from 'src/app/service/progress.service';
import { InputTextModule } from 'primeng/inputtext';
import { Button, ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
  selector: 'app-security-and-privacy-page',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PasswordModule,
    InputTextModule,
    ButtonModule,
    FloatLabelModule,
  ],
  templateUrl: './security-and-privacy-page.component.html',
  styleUrl: './security-and-privacy-page.component.scss'
})
export class SecurityAndPrivacyPageComponent implements OnInit {

  protected passwordOld: string;
  protected password: string;
  protected newPassword: string;
  protected changeCheck: boolean = false;
  protected emailChangeCheck: boolean = false;
  protected confirmationCodeCheck: boolean = false;
  protected emailCurrent: string;
  protected emailNew: string;
  protected confirmationCode: string;

  constructor(protected dataService: DataService, protected progressService: ProgressService){

  }

  async ngOnInit() {
    this.emailCurrent = this.dataService.getUserEmail();
  }

  async updatePassword() {
    
    this.progressService.blockWithMessage("Updating Password");

    const output = await this.dataService.handleUpdatePassword({oldPassword: this.passwordOld, newPassword: this.password});

    if (output === "DONE") {
      console.log("Successfully updated password");
      this.changeCheck = true;
    }

    this.progressService.unBlock();
  }

  async sendConfirmationCode () {

    const output = await this.dataService.handleUpdateEmail(this.emailNew);
    

    if (output === "DONE") {
      console.log("Successfully sent code.");
      this.confirmationCodeCheck = true;
    }


  }

  async updateEmail() {
    this.progressService.blockWithMessage("Updating Email");

    const output = await this.dataService.handleConfirmUpdateEmail({userAttributeKey: 'email', confirmationCode: this.confirmationCode});

    if (output === "DONE") {
      console.log("Successfully updated email.");
      this.emailChangeCheck = true;
      this.fetchCurrentEmail();
    }

    this.progressService.unBlock();

  }

  async fetchCurrentEmail() {
    this.emailCurrent = await this.dataService.fetchUserEmail();
  }

}
